import { render } from "./SeicoMart.vue?vue&type=template&id=2f65779e"
import script from "./SeicoMart.vue?vue&type=script&setup=true&lang=js"
export * from "./SeicoMart.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/blogs/SeicoMart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2f65779e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2f65779e', __exports__)) {
    api.reload('2f65779e', __exports__)
  }
  
  module.hot.accept("./SeicoMart.vue?vue&type=template&id=2f65779e", () => {
    api.rerender('2f65779e', render)
  })

}


export default __exports__